// extracted by mini-css-extract-plugin
export default {"content":"select-info-message_content__z+Hwt","icon":"select-info-message_icon__h4oKG"};